import { SignUpCompanyPartnerPanel } from "@/components/panel/SignUpCompanyPartnerPanel";
import { SignUpPersonalPartnerPanel } from "@/components/panel/SignUpPersonalPartnerPanel";
import { H4 } from "@/components/typography/H4";
import { SignUpTab } from "@/types/sign-up-tab";
import { Tabs } from "flowbite-react";
import { useState } from "react";

export default function SignUpPage() {
  const [activeTab, setActiveTab] = useState(SignUpTab.PERSONAL);

  const handleTabChange = (tabIndex: number) => {
    if (tabIndex === 0) {
      setActiveTab(SignUpTab.PERSONAL);
    } else {
      setActiveTab(SignUpTab.COMPANY);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="flex flex-col items-center w-[400px]">
        <H4 className="text-semantic-text-heading mb-[20px]">
          마스터 발주몰 회원가입
        </H4>
        <Tabs
          className="w-full"
          variant="underline"
          onActiveTabChange={handleTabChange}
        >
          <Tabs.Item title="개인 사업자" active={activeTab.isPersonal()} />
          <Tabs.Item title="법인 사업자" active={activeTab.isCompany()} />
        </Tabs>
        {activeTab.isPersonal() && <SignUpPersonalPartnerPanel />}
        {activeTab.isCompany() && <SignUpCompanyPartnerPanel />}
      </div>
    </div>
  );
}
